import React, { useState } from "react";
import { OVERVIEW } from "../../../core/theme/reportTheme";
import { BUSINESS_TYPES } from "../../../core/data/businessTypes/classifyBusiness";
import { BUSINESS_TYPE_LABELS } from "../../../core/data/businessTypes/labels";

// Business types are shown by name only - no colour per type (Scott, 15 Oct 2026).

// The business type correction menu, shared by every page that offers it.
// const { openMenu, menu } = useTypeMenu(onSetType);
//   openMenu(advertiser, clickEvent)  advertiser = { key, displayName, businessType }
//   {menu}                            put this anywhere in the page
export function useTypeMenu(onSetType) {
  const [state, setState] = useState(null); // { advertiser, top, left }

  const openMenu = (advertiser, event) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    const top = Math.min(rect.bottom + 4, window.innerHeight - 240);
    const left = Math.min(rect.left, window.innerWidth - 220);
    setState({ advertiser, top, left });
  };

  const choose = async (type) => {
    const { advertiser } = state;
    setState(null);
    const error = await onSetType(advertiser.key, type);
    if (error) alert(`Couldn't save the business type: ${error}`);
  };

  const menu = state ? <TypeMenu menu={state} onChoose={choose} onClose={() => setState(null)} /> : null;
  return { openMenu, menu };
}

// Small menu to correct an advertiser's business type.
function TypeMenu({ menu, onChoose, onClose }) {
  const { advertiser } = menu;
  return (
    <>
      <div className="fixed inset-0 z-[999]" onClick={onClose} />
      <div className={OVERVIEW.menu} style={{ top: menu.top, left: menu.left }}>
        <p className={OVERVIEW.menuNote}>Classify {advertiser.displayName} as:</p>
        {BUSINESS_TYPES.map(t => (
          <button key={t} type="button" onClick={() => onChoose(t)} className={OVERVIEW.menuItem}>
            <span className={advertiser.businessType.type === t ? "font-semibold" : ""}>{BUSINESS_TYPE_LABELS[t]}</span>
          </button>
        ))}
        {advertiser.businessType.basis === "manual" && (
          <button type="button" onClick={() => onChoose(null)} className={`${OVERVIEW.menuItem} border-t border-slate-100 mt-1`}>
            Undo correction (use AdAudit's)
          </button>
        )}
      </div>
    </>
  );
}
